import { createRoot } from 'react-dom/client';
import './fonts.css';
import './tokens.generated.css';
import '../../../design-source/design-system/components/bundle.css';
import './app.css';
import { App } from './App.tsx';

createRoot(document.getElementById('root')!).render(<App />);
